import React from 'react'

const AboutMe = (props) => {

    let text1 = "";
    let text3 = "";
    let text4 = "";
    let text5 = "";
    let text6 = "";
    

    if (props.language === "English"){
        //console.log("esoy leyendo el if de presentation")
        text1 = "I'm from Argentina and I'm 35 years old.";
        text3 = "I have a degree in Biotechnology since 2010, and I made some postgraduate courses in the matter.";
        text4= "I started to learn coding for curiosity and I found it very amusing and challenging. I love the thinking proccess to apply logic, the idea of dividing the problem in small pieces and go step by step. I use to get very stusiastic with the stylishing of my page, I really work to make real my envision of the project, even if I don't have the skills o knowledge for that: I research until I get satisfied with the outcome."
        text5="All my education in programing was made through free courses with out a coach to consult, meaning that I got here in an autodidactic way."
        text6="My level of English is advanced in writing and listening and intermediate / pre-advanced in speaking."
        
    } else if (props.language === "Spanish"){
        text1 = "Soy de Argentina y tengo 35 años.";
        text3 = "Soy Licenciada en Biotecnología, egresada en 2010, y realicé varios cursos de posgrado en la temática.";
        text4= "Empecé a aprender programación por curiosidad y lo encontré muy entretenido y desafiante. Me encanta el proceso de razonamiento para aplicar la lógica, la idea de dividir el problema en pequeñas piezas e ir abordándolas una por una. Me entusiasma mucho darle estilo a mis páginas, intento hacer real mi visión del proyecto, incluso aunque no cuente con las herramientas o el conocimiento para ello: investigo hasta sentirme conforme con el resultado."
        text5="Toda mi educación en programación fue realizada a través de cursos gratuitos on line, sin un instructor a quién consultar, es decir que llegué hasta aquí de forma autodidacta."
        text6="Mi nivel de Inglés es avanzado en escritura e interpretación auditiva, e intermedio / pre-avanzado en exposición oral."
        
    } 

    return (
        <div id='AboutMe '>
            <div className= "aboutMeContainer">

                <p>{text1}</p>
                <p>{text3}</p>
                <br></br>
                <p>{text4}</p>
                <p>{text5}</p>
                <br></br>
                <p>{text6}</p>

               <button id="closeButton" type="button" class="btn-close btn-close-white" aria-label="Close" onClick={props.closeAboutMe}></button>
            </div>
        </div>
    )
}

export default AboutMe